import { trainingVersionRepository } from "../../../providers/repositories/trainingVersionRepository";
import { TrainingVersion } from "../entities/TrainingVersion";
import { toast } from "react-toastify";
import { t } from "i18next";
import Logger from "../../../utils/Logger";

export const getAllTrainingVersionsUseCase = {
  async exec(trainingId: string): Promise<TrainingVersion[]> {
    try {
      return await trainingVersionRepository.getAll(trainingId);
    } catch (error) {
      Logger.error("getAllTrainingVersionsUseCase", error);
      toast.error(t("action.error"));
    }
    return [];
  },
};
